<script setup>
import {computed, onMounted, ref, watch} from "vue";
import store from "@/store";
import {game} from "@/utils/config";
import LoginComponents from "@/components/login/LoginComponents.vue";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";

const type = computed(() => {
  let type = store.state.coupon;
  if (type) {
    return game[type]
  }
  return {}
});
const showLogin = ref(false);
const account = computed(() => {
  return store.state.account;
});
const scroll = ref();
watch(account, (to) => {
  if (Object.keys(to).length < 1) {
    showLogin.value = true;
    return;
  }
  getOrder(1);
})
onMounted(async () => {
  store.commit('getCoupon');
  await store.dispatch('getAccounts')
  document.title = type.value.title;
  // await getOrder(1);
})
const page = ref(1)
const lastPage = ref(1)
const orderLst = ref([])
const getOrder = p => {
  showLogin.value = false;
  if (Object.keys(account.value).length < 1) return;
  page.value = p || 1;
  new axiosApi({
    encode: "coupon",
    method: "life/orderLst",
    body: {
      cust_id: account.value.cust_id,
      type: `${type.value.coupon}`,
      page: page.value
    }
  }).send(res => {
    if (res.message.code !== "000") return
    const result = res.data.data.map(item => {
      if (item.goodsItems.remarks)
        item.goodsItems.remarks = item.goodsItems.remarks ? JSON.parse(item.goodsItems.remarks) : {};
      return item
    });
    orderLst.value = p === 1 ? res.data.data : orderLst.value.concat(res.data.data);
    lastPage.value = res.data.last_page;
  })
}
const backHome = () => {
  router.replace({name: 'home'})
}

const onScrollbar = (refs) => {
  let warp = refs.wrapRef;
  const poor = warp.scrollHeight - warp.clientHeight;
  if (poor === parseInt(warp.scrollTop) || poor === Math.ceil(warp.scrollTop) || poor === Math.floor(warp.scrollTop)) {
    console.log(page.value, lastPage.value)
    if (page.value < lastPage.value) {
      getOrder(page.value + 1)
    }
  }
}
// const showCityLst = ()=>{}
</script>

<template>
  <div class="order-view page-pid" :class="type.coupon" :style="type.style">
    <div class="header">
      <div class="header-left" @click="backHome">
        <el-icon>
          <ArrowLeft/>
        </el-icon>
      </div>
      <div class="header-left">兑换记录</div>
      <div class="header-left"></div>
    </div>
    <el-scrollbar class="order-lst" ref="scroll" @scroll="onScrollbar(scroll)">
      <component :is="type.coupon+'_order'" :order-lst="orderLst"/>
    </el-scrollbar>
  </div>
  <login-components :show-login="showLogin" v-if="showLogin"/>
</template>

<style scoped lang="less">
.order-view {
  //background: url("@/assets/images/dzpd/order-bg.png") no-repeat;

  height: 100vh;
  box-sizing: border-box;
  overflow-y: hidden;

  .header {
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.2rem;
    margin-left: 15px;
    color: #ffffff;
  }

  &.qxdj {
    background: url("@/assets/images/qxdj/order-bg.png") no-repeat;
    background-size: 100% auto;
  }

  &.kaojiang {
    background: url("@/assets/images/kaojiang/order-bg.png") no-repeat;
    background-size: 100% auto;

    .header {
      color: #000000;
    }
  }

  &.mosuannai {
    background: url("@/assets/images/mos/order-bg.png") no-repeat;
    background-size: 100% auto;

    .header {
      color: #000000;
    }
  }

  .order-lst {
    height: calc(100vh - 65px);
    padding: 10px 15px;
  }
}
</style>
